import { del, get, post, put } from "../util/http.service";

export const apiGetPurchases = params => ({
  queryKey: ["purchases", params],
  queryFn: () => get("/api/purchases", params),
  placeholderData: (previousData) => previousData
});

export const apiCreatePurchase = () => ({
  mutationFn: data => post("/api/purchases", data)
});

export const apiUpdatePurchase = id => ({
  mutationFn: data => put("/api/purchases/" + id, data)
});

export const apiArchivePurchase = () => ({
  mutationFn: id => put("/api/purchases/" + id + "/archive", {})
});

export const apiDeletePurchase = () => ({
  mutationFn: id => del("/api/purchases/" + id)
});
